import React, { useContext, useEffect, useState } from "react"
import auxService from "../../services/AuxService";
import { Button, Form, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faAsterisk, faCheck, faDoorClosed, faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";
import { EmpresaInterface } from "../../interfaces";
import { AuthContext } from "../../contexts/AuthContext";
import { useQuestion } from "../../components/ModalQuestion/useModalQuestion";
import { useModalMessage } from "../../components/ModalMessage/useModalMessage";

interface FormProps {
    show: boolean;
    id: string;
    onHide: () => void;
    dados: EmpresaInterface[];
    setDados: React.Dispatch<React.SetStateAction<EmpresaInterface[]>>
}

interface DadosComprador {
    comprador_nome: string;
    comprador_cpfcnpj: string;
    valor: number;
}

interface FormData {
    podeDevolver: boolean;
    nome_empresa: string;
    cnpj_empresa: string;
    dados_devolucao: DadosComprador;
    isMatriz: boolean;
}

const initialState: FormData = {
    podeDevolver: false,
    nome_empresa: '',
    cnpj_empresa: '',
    isMatriz: false,
    dados_devolucao: {
        comprador_nome: '',
        comprador_cpfcnpj: '',
        valor: 0
    }
}

export const ModalFormCancelamento: React.FC<FormProps> = ({ id, show, onHide, dados, setDados }) => {
    const [formComprador, setFormComprador] = useState<FormData>(initialState);
    const authContext = useContext(AuthContext);
    const { confirm, ConfirmModal } = useQuestion();
    const { alertModal, ModalMessageEl } = useModalMessage();
    useEffect(() => {
        //1. carregar dados da empresa a ser cancelada
        //2. verificar se esta dentro do prazo de 7 dias para devolução do dinheiro,
        //   se for o caso, enviar email para o adminstrador com os dados do cpf e nome
        //   para fazer a devolucao, dos dados tem que se os mesmos que pagaram a licença
        //   deve exibir de forma somente leitura os dados do pagar e checkbox de aceite
        //3. marcar empresa cancelar para não ser cobrado na proximo renovacao da assinatura
        //4. 

        auxService.getPagamentoLicenca(id)
            .then(res => {
                setFormComprador(res);
            })
            .catch(error => console.log(error))

    }, [])

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const confirmed = await confirm({
            message: "Deseja realmente cancelar",
            title: "Cancelamento",
            btnConfirmOptions: {
                icon: faCheck,
                title: "Sim, Cancelar",
                variant: 'success'
            }
        })
        if (confirmed) {

            await auxService.cancelarLicenca(id)
                .then(async res => {
                    const canceled = await confirm({
                        title: "Atenção",
                        message: "Operação realizada com sucesso!",
                        btnConfirmOptions: {
                            icon: faCheck,
                            title: 'OK',
                            variant: 'success',
                        },
                        btnCancelShow: false
                    });

                    if (canceled) {
                        if (!formComprador.isMatriz) {
                            setDados(dados.map(item => item.id.toString() === id.toString()
                                ? { ...item, active: false } : item))
                            onHide();
                            authContext?.updateStatusEmpresa(id.toString(), false);

                        } else {
                            authContext?.logout();
                        }
                    }

                })
                .catch(error => {
                    alertModal(error.response.data.message, 'danger');
                });
        }
    }

    return (
        <Modal show={show} onHide={() => { onHide(); }} size={'lg'} centered backdrop='static'>
            <Modal.Header closeButton className="bg-danger">
                <Modal.Title className="h6 text-light"> <FontAwesomeIcon color="yellow"
                    icon={faExclamationTriangle} />  Cancelamento - Leia com atenção!!!</Modal.Title>
            </Modal.Header>
            <Modal.Body >

                <p className="ms-1 text-wrap">
                    <FontAwesomeIcon icon={faAsterisk} className="text-danger" /> Ao confirmar o cancelamento, a próxima
                    renovação <strong>NÃO</strong> será cobrado anuidade dessa empresa e não será
                    mais possível acessar os manifestos emitidos.
                </p>

                <p className="ms-1">
                    <FontAwesomeIcon icon={faAsterisk} className="text-danger" /> Verifique seu email para
                    saber se é elegível a restituição do valor pago em caso de cancelamento no
                    prazo de 7 dias corridos. Caso seja, o reembolso será feito em 72h após a solicitação do
                    cancelamento. Os XMLs dos manifestos serão enviados em até 30 dias. Todos os dados da empresa
                    serão removidos em 1 ano.
                </p>

                {formComprador.isMatriz && (
                    <p className="ms-1 text-wrap">
                        <FontAwesomeIcon
                            icon={faAsterisk}
                            className="text-danger" /> <FontAwesomeIcon
                            icon={faAsterisk}
                            className="text-danger" /> Você está tentando cancelar a matriz, o processo irá também
                        cancelar <strong>TODAS</strong> as filiais.
                    </p>
                )}
                <p className="ms-1">
                    Confirma o cancelamento da empresa ?
                </p>

                <span className="ms-1">Nome: <strong>{formComprador.nome_empresa} </strong></span>
                <br />
                <span className="ms-1">CNPJ: <strong>{formComprador.cnpj_empresa}</strong></span>

            </Modal.Body>

            <Modal.Footer>
                <Form onSubmit={handleSubmit}>
                    <Button variant="danger" type="submit" >
                        <FontAwesomeIcon icon={faCheck} /> Confirmar cancelamento
                    </Button>
                </Form>
                <Button variant="secondary" onClick={() => { onHide(); }}>
                    <FontAwesomeIcon icon={faDoorClosed} /> Fechar
                </Button>
            </Modal.Footer>
            {ModalMessageEl}
            {ConfirmModal}
        </Modal>

    );
}